// Wizard-only policy; other chat editors keep their existing behavior.
function selectionError(selection) {
    if (selection && selection.mode === 'manual') return '';
    if (!selection || selection.mode !== 'preset' || !Number.isSafeInteger(Number(selection.group_id)) || Number(selection.group_id) <= 0) return 'Выберите группу сотрудников или ручной состав';
    return selection.applied === true ? '' : 'Нажмите «Добавить сотрудников и подтвердить состав»';
}
function wizardGroupName(kind, objectName, purpose) {
    const name = String(objectName || '').trim();
    if (kind === 'main') return name;
    const prefix = {itr: 'ИТР', supply: 'Снабжение', mechanics: 'Механики'}[kind] || String(purpose || '').trim();
    return prefix && name ? prefix + ' - ' + name : '';
}
module.exports = {selectionError, wizardGroupName};
